import AuthStore from 'common/authStore';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import { Alert, Col, Row } from 'antd';
import { CuriousLogo2, LoginLeftBg, tcs3 } from 'assets';
// import { Button, Form, Input } from 'antd';
import { fetchUserDetails, fetUserRole, setUserData } from './auth.action';

import './styles.scss';
import { AUTH_STATUS } from 'common/constants';
import Loader from 'components/ui/Loader';

// import { useState } from "react";
import { Row, Col, Form, Input, Button, Alert, Spin } from 'antd';
// import { AUTH_STATUS } from "./constants"; // Assuming you have AUTH_STATUS defined
// import Loader from "./Loader"; // Assuming you have a Loader component
// import LoginLeftBg from "./LoginLeftBg.png"; // Replace with actual import
// import SfsDark from "./SfsDark.png"; // Replace with actual import
// import CuriousLogo from "./CuriousLogo.png"; // Replace with actual import
// import "./Login.css"; // New CSS file for responsiveness

function Login({ children }) {
  const token = AuthStore.accessToken;
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth);
  const { isError, isAuthorized, loading, tokenExpired } = userData;
  // const currentTime = new Date().getTime();

  useEffect(() => {
    if (token) {
      dispatch(setUserData(token));
      dispatch(fetUserRole());
    }

    // eslint-disable-next-line
  }, [token, tokenExpired]);

  /*  useEffect(() => {
    // Token expiration time (example: 1729027815)
    const tokenExpireTime = AuthStore.expireat;
    const currentTime = Math.floor(Date.now() / 1000);
    if (currentTime >= tokenExpireTime) {
      AuthStore.emptyStore();
      setIsTokenExpired(true);
    } else {
      setIsTokenExpired(false);
    }
    const interval = setInterval(() => {
      console.log('interval');
      const updatedTime = Math.floor(Date.now() / 1000);
      if (updatedTime >= tokenExpireTime) {
        console.log('expired');
        setIsTokenExpired(true);
      }
    }, 1000); // Check every second

    // Clean up the interval on component unmount
    return () => clearInterval(interval);
  }, []); */

  const onFinish = (values) => {
    const finalpayload = {
      ...values,
      userInfo: {
        ip: 'string',
        city: 'string',
        country: 'string',
        browserName: 'string'
      }
    };
    dispatch(fetchUserDetails(finalpayload));
    // const token =
    //   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c';
    // AuthStore.accessToken = token;

    // dispatch(fetchUserDetailsfalse());
    // location.reload();
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  // setInterval(() => {
  //   if (accessToken != '' && currentTime < expireatStamp) {
  //       mid.refresh().then(() => {
  //         const access_token = mid.accessToken();
  //         AuthStore.accessToken = access_token;
  //       });
  //   }
  // }, 900000);

  const submitForm = () => {
    sessionStorage.removeItem('prevroute');
    console.log('submit login form');
  };

  // return isAuthorized === AUTH_STATUS.Authorized ? (
  //   children
  // ) : (
  //   <div className="login-container" onClick={submitForm}>
  //     {loading && <Loader />}
  //     <Row>
  //       <Col span={12} className="login-leftbg">
  //         <img src={LoginLeftBg} alt="login left bg" />
  //       </Col>
  //       <Col span={12} className="login-right">
  //         <div className="logosection">
  //           <div className="leftlogo">
  //             <img src={SfsDark} alt="logo" />
  //           </div>
  //           <div className="rightlogo">
  //             <img src={CuriousLogo} alt="logo" />
  //           </div>
  //         </div>
  //         <div className="loginresize">
  //           <div className="login-header">
  //             <h1>Log in</h1>
  //             <p>Welcome back!</p>
  //             {isError && (
  //               <Alert
  //                 style={{ marginBottom: 15 }}
  //                 type="error"
  //                 message="The username or password is incorrect"
  //               />
  //             )}
  //           </div>
  //           <Form
  //             name="login"
  //             style={{
  //               maxWidth: 600
  //             }}
  //             size="large"
  //             onFinish={onFinish}
  //             onFinishFailed={onFinishFailed}
  //             layout="vertical"
  //             autoComplete="off"
  //           >
  //             <Form.Item
  //               label="Username"
  //               name="userName"
  //               rules={[
  //                 {
  //                   required: true,
  //                   message: 'Please input your username!'
  //                 }
  //               ]}
  //             >
  //               <Input placeholder="" />
  //             </Form.Item>

  //             <Form.Item
  //               label="Password"
  //               name="key"
  //               size="large"
  //               rules={[
  //                 {
  //                   required: true,
  //                   message: 'Please input your password!'
  //                 }
  //               ]}
  //             >
  //               <Input.Password placeholder="" />
  //             </Form.Item>

  //             <Form.Item>
  //               <Button block size="large" type="primary" htmlType="submit">
  //                 Log in
  //               </Button>
  //             </Form.Item>
  //           </Form>
  //           <div className="copywritelogin">&copy; 2025 Curious Insights | All Rights Reserved</div>
  //         </div>
  //       </Col>
  //     </Row>
  //   </div>
  return isAuthorized === AUTH_STATUS.Authorized ? (
    children
  ) : (
    <div className="login-container" onClick={submitForm}>
      {loading && <Loader />}
      <Row className="login-row">
        <Col xs={0} md={12} className="login-leftbg">
          <img src={LoginLeftBg} alt="login left bg" />
        </Col>
        <Col xs={24} md={12} className="login-right">
          <div>
            <div className="logosection">
              <img src={tcs3} alt="logo" className="leftlogo" />
              <img src={CuriousLogo2} alt="logo" className="rightlogo" />
            </div>
            <div className="login-content">
              <h3>Please enter your credentials</h3>
              {/* <p>Welcome back!</p> */}
              {isError && (
                <Alert
                  style={{ marginBottom: 15 }}
                  type="error"
                  message="The username or password is incorrect"
                />
              )}
              <Form
                name="login"
                className="login-form"
                size="large"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                layout="vertical"
                autoComplete="off"
              >
                <Form.Item
                  label="Username"
                  name="userName"
                  rules={[{ required: true, message: 'Please input your username!' }]}
                >
                  <Input placeholder="" />
                </Form.Item>

                <Form.Item
                  label="Password"
                  name="key"
                  rules={[{ required: true, message: 'Please input your password!' }]}
                >
                  <Input.Password placeholder="" />
                </Form.Item>

                <Form.Item>
                  <Button block type="primary" htmlType="submit">
                    {loading ? <Spin /> : 'Log in'}
                  </Button>
                </Form.Item>
              </Form>
              <div className="copywritelogin">
                &copy; 2025 Curious Insights | All Rights Reserved
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Login;
